import { defineStyleConfig } from "@chakra-ui/react";

const Divider = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    // borderWidth: 2,
    // borderColor: "gray.300",
  },
});

export default Divider;
